import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  Companies,
  Countries,
  GridSchemaSearchResponse,
  LevelsRedemptionTypes,
  Nexus,
  SchemaSearchResponse,
} from '../models/schemas.model';

export const LoadSchemaData = createAction('[Schemas: Search]: Load Schema Data');

export const GetNexusSuccess = createAction(
  '[Schemas: Search]: Get Nexus Success',
  props<{ res: Nexus[] }>(),
);

export const GetNexusFailed = createAction(
  '[Schemas: Search]: Get Nexus Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCompaniesSuccess = createAction(
  '[Schemas: Search]: Get Companies Success',
  props<{ res: Companies[] }>(),
);

export const GetCompaniesFailed = createAction(
  '[Schemas: Search]: Get Companies Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLevelsSuccess = createAction(
  '[Schemas: Search]: Get Levels Success',
  props<{ res: LevelsRedemptionTypes[] }>(),
);

export const GetLevelsFailed = createAction(
  '[Schemas: Search]: Get Levels Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetTaxOfficesSuccess = createAction(
  '[Schemas: Search]: Get TaxOffices Success',
  props<{ res: SchemaSearchResponse }>(),
);

export const GetTaxOfficesFailed = createAction(
  '[Schemas: Search]: Get TaxOffices Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetRedemptionTypesSuccess = createAction(
  '[Schemas: Search]: Get RedemptionTypes Success',
  props<{ res: LevelsRedemptionTypes[] }>(),
);

export const GetRedemptionTypesFailed = createAction(
  '[Schemas: Search]: Get RedemptionTypes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountriesSuccess = createAction(
  '[Schemas: Search]: Get Countries Success',
  props<{ res: Countries[] }>(),
);

export const GetCountriesFailed = createAction(
  '[Schemas: Search]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SearchPanelStatusChanged = createAction(
  '[Schemas: Search]: Search Panel Status Changed',
);

export const SchemaCodeChanged = createAction(
  '[Schemas: Search]: Schema Code Changed',
  props<{ schemaCode: string }>(),
);

export const CompanyTitleChanged = createAction(
  '[Schemas: Search]: Company Title Changed',
  props<{ companyTitle: string }>(),
);

export const VATNumberChanged = createAction(
  '[Schemas: Search]: VAT Number Changed',
  props<{ vatNumber: string }>(),
);

export const ClearSchemaOptions = createAction('[Schemas: Search]: Clear Schema Options');

export const SearchSchemas = createAction('[Schemas: Search]: Search Schemas');

export const SearchSchemasSuccess = createAction(
  '[Schemas: Search]: Search Schemas Success',
  props<{ res: SchemaSearchResponse }>(),
);

export const SearchSchemasFailed = createAction(
  '[Schemas: Search]: Search Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CountSearchSchemas = createAction('[Schemas: Search]: Count Search Schemas');

export const CountSearchSchemasSuccess = createAction(
  '[Schemas: Search]: Count Search Schemas Success',
  props<{ res: number }>(),
);

export const CountSearchSchemasFailed = createAction(
  '[Schemas: Search]: Count Search Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenEditSchema = createAction('[Schemas: Search]: Open Edit Schema');

export const CloseEditSchema = createAction('[Schemas: Search]: Close Edit Schema');

export const EditSchema = createAction(
  '[Schemas: Search]: Edit Schema',
  props<{ row: GridSchemaSearchResponse }>(),
);
